import React from 'react'
import { useSelector } from 'react-redux'
import { StripeInfoCard } from './StripeInfoCard'
import CheckoutForm from '../CheckoutForm'
import Skeleton from 'react-loading-skeleton'
import { checkoutLoading, pagesShowCheckoutFormSelector } from '../../redux/selectors/pagesSelectors'
import { cartCartSelector, cartMainProduct as cartMainProductSelector } from '../../redux/selectors/cartSelector'
import { authEmailSelector } from '../../redux/selectors/authSelectors'

export default function StripeSection ({ stripe, stripeLoad, handleStripe, checkoutTitleStripe, pagesClientSecret }) {
    const email = useSelector(authEmailSelector)
    const checkoutIsLoading = useSelector(checkoutLoading)
    const pagesShowCheckoutForm = useSelector(pagesShowCheckoutFormSelector)
    const cart = useSelector(cartCartSelector)
    const cartMainProduct = useSelector(cartMainProductSelector)
    let titleStripe = checkoutTitleStripe;

    const shouldShowCheckoutForm =
        Boolean(pagesShowCheckoutForm) &&
        Boolean(pagesClientSecret) &&
        !checkoutIsLoading

    let content = null
    let stripeCardActive = false
    let descStripe =  null;

    const noDomains = cartMainProduct?.product_id === 5 && (!cart?.domains || cart.domains.length === 0)

    if (!email || stripeLoad.error) {
        stripeCardActive = !stripeLoad.error
        content = 'card'
    } else if (noDomains) {
        stripeCardActive = false
        content = 'card'
    } else if (shouldShowCheckoutForm) {
        content = 'checkout'
    } else if ((!shouldShowCheckoutForm || checkoutIsLoading) && stripeLoad?.error !== true) {
        content = 'skeleton'
    } else {
        stripeCardActive = false
        content = 'card'
    }

    if (cart?.uiModeFromQuery === 'hosted') {
        content = 'card'
        titleStripe = 'UI mode has been enabled.';
        descStripe = 'UI mode has been enabled.';
        stripeCardActive = false
    }

    switch (content) {
        case 'card':
            return (
                <StripeInfoCard
                    activeBox={stripeCardActive}
                    checkoutTitleStripe={titleStripe}
                    buttonClassName="button--proceed"
                    showButton
                    onClick={handleStripe}
                    loading={stripeLoad.error || checkoutIsLoading}
                    descStripe={descStripe ?? null}
                />
            )
        case 'checkout':
            return (
                <CheckoutForm
                    key={pagesClientSecret}
                    stripe={stripe}
                    pagesClientSecret={pagesClientSecret}
                />
            )
        case 'skeleton':
            return <Skeleton className="skeleton--top" height={620}/>
        default:
            return null
    }
}
